module.exports = __webpack_public_path__ + "assets/Atlassian.c8464b2e.svg";